import { render, staticRenderFns } from "./Interest.vue?vue&type=template&id=3488badb&scoped=true"
import script from "./Interest.vue?vue&type=script&lang=js"
export * from "./Interest.vue?vue&type=script&lang=js"
import style0 from "./Interest.vue?vue&type=style&index=0&id=3488badb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3488badb",
  null
  
)

export default component.exports